import { useDispatch, useSelector } from 'react-redux';
import { optionSteps } from 'common/constants/menu';

import {
  getDishOptions,
  changeFormStep,
  updateOrCreate,
  resetListData as resetListDataAction,
  resetErrors,
  deleteOptions,
} from './actions';
import {
  dishOptionListDataSelector,
  dishOptionCompletedStepsSelector,
  dishOptionStepSelector,
  dishOptionErrorsSelector,
  dishOptionDeleteInProcessSelector,
  dishOptionCreateOrUpdateInProcessSelector,
} from './selectors';
import { useHistory } from 'react-router-dom';

export const useDishOptions = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const listData = useSelector(dishOptionListDataSelector);
  const errors = useSelector(dishOptionErrorsSelector);
  const deleteInProcess = useSelector(dishOptionDeleteInProcessSelector);
  const createOrUpdateInProcess = useSelector(dishOptionCreateOrUpdateInProcessSelector);

  const step = useSelector(dishOptionStepSelector);
  const completedSteps = useSelector(dishOptionCompletedStepsSelector);

  const handleGetDishOptions = () => {
    dispatch(getDishOptions());
  };

  const handleResetErrors = () => {
    if (errors) {
      dispatch(resetErrors());
    }
  };

  const handleUpdateOrCreate = (data, id) => {
    dispatch(updateOrCreate({ data, history, id }));
    // UIHelper.successNotification('TODO');
  };

  const handleChangeDishStep = (nextStep) => {
    dispatch(
      changeFormStep({
        step: nextStep,
        completedSteps: [...completedSteps, nextStep],
      }),
    );
  };

  const resetListData = () => {
    dispatch(resetListDataAction());
  };

  const handleResetSteps = () => {
    dispatch(
      changeFormStep({
        step: optionSteps.first,
        completedSteps: [optionSteps.first],
      }),
    );
  };

  const handleDelete = id => {
    dispatch(deleteOptions({ id, history }));
  };

  return {
    handleResetErrors,
    handleGetDishOptions,
    listData,

    step,
    completedSteps,
    handleChangeDishStep,
    handleResetSteps,
    handleUpdateOrCreate,
    resetListData,
    handleDelete,
    errors,
    deleteInProcess,
    createOrUpdateInProcess,
  };
};
